import store from '../../store'
// eslint-disable-next-line import/prefer-default-export
export const access = {
  // eslint-disable-next-line no-shadow
  can(value) {
    // eslint-disable-next-line no-shadow
    let access = 0
    if (store.state.permission.permissions === 0) {
      return false
    }
    access=store.state.permission.permissions.data
    const { permissions } = access
    // eslint-disable-next-line no-underscore-dangle
    let _return = false
    if (!Array.isArray(permissions)) {
      return false
    }
    if (value.includes('^')) {
      value.split('^').forEach(item => {
        if (permissions.includes(item.trim())) {
          _return = true
        }
      })
    } else if (value.includes('&')) {
      _return = true
      value.split('&').forEach(item => {
        if (!permissions.includes(item.trim())) {
          _return = false
        }
      })
    } else {
      _return = permissions.includes(value.trim())
    }

    return _return
  },
  // eslint-disable-next-line no-unused-vars
  is(value) {
    let access = 0
    if (store.state.permission.permissions === 0) {
      return false
    }
    access=store.state.permission.permissions.data
    const { roles } = access
    // eslint-disable-next-line no-underscore-dangle
    let _return = false
    if (!Array.isArray(roles)) {
      return false
    }
    if (value.includes('^')) {
      value.split('^').forEach(item => {
        if (roles.includes(item.trim())) {
          _return = true
        }
      })
    } else if (value.includes('&')) {
      _return = true
      value.split('&').forEach(item => {
        if (!roles.includes(item.trim())) {
          _return = false
        }
      })
    } else {
      _return = roles.includes(value.trim())
    }

    return _return
  },
}
